<template>
  <div class="mvt-collapsiblelinks grid xs-grid-cols-1">
    <component :is="titleTag" :class="titleClass" v-if="title">{{ title }}</component>
    <ul :class="`mvt-collapsiblelinks__grid grid xs-grid-cols-1 sm-grid-cols-2 md-grid-cols-${numCols}`">
      <li v-for="(item, index) in links" class="singleline" :class="addLinkGridItem ? 'mvt-collapsiblelinks__grid-item' : ''" :style="{display: (index > limit-1 && !isExpanded)?'none':'block'}">
        <div v-if="isLinkList(item)" :key="`list-${index}`">
          <template v-for="(subitem, subIndex) in (item.multipart ? item.parts : item)" :key="`list-${index}-${subIndex}`">
            <a v-if="subitem.url" v-html="subitem.text" class="link" :class="{'d-block': !item.multipart}" :href="subitem.url"></a><template v-if="item.multipart">{{ " " }}</template>
          </template>
        </div>
        <a v-else-if="item.url" class="link" v-html="item.text" :href="item.url" :key="`single-${index}`"></a>
        <slot name="reorgLink" :reorgItem="item" :index="index"></slot>
      </li>
    </ul>
    <slot name="link"></slot>
    <a v-if="!forceExpanded" href="#" role="button" :aria-label="isExpanded ? 'View Less' : 'View All'" class="more link" :class="{'hide' : links.length<=limit}" @click.prevent="toggle()">{{isExpanded ? 'View Less' : 'View All'}}</a>
  </div>
</template>

<script src="./mvt-collapsiblelinks.js">
</script>

<style lang="scss">
@use "./mvt-collapsiblelinks.scss" as *;
</style>